import {componentConfig, componentLoader} from "../../lib/component_initializer";
import {CsBubble, CsBubbleConfig} from "./cs_bubble";

export const csBubbleLoader = function(options={}){
    componentLoader(componentConfig(CsBubble, CsBubbleConfig.componentTypeKey, CsBubbleConfig.baseHtmlClass), options);
}